import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useWidgetContainerStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.5,
    backgroundColor: customTokens.colorNeutralCardBackground2,
    padding: tokens.spacingVerticalXL,
    rowGap: 0,
    boxShadow: 'none',
  },
  title: {
    fontWeight: customTokens.fontWeightBold,
    fontSize: customTokens.fontSizeBase400,
    ...shorthands.margin(
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalXL,
      tokens.spacingHorizontalNone,
    ),
  },
  footer: {
    display: 'flex',
    marginTop: customTokens.spacingVerticalXL,
  },
});
